import { useQuery } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { GetGroups } from "./apiEcms.types";

const getGroups = async (signal: AbortSignal) => {
  const { data } = await apiEcmsHttp.get<GetGroups>("/groups", {
    signal,
  });

  return data;
};

export const useGetGroups = () =>
  useQuery({
    queryKey: [QUERY_KEYS.GROUPS],
    queryFn: ({ signal }) => getGroups(signal),
    select: (res) => res.groups,
    retryOnMount: false,
  });
